import { render, staticRenderFns } from "./checkpeople.vue?vue&type=template&id=614268a6&scoped=true&"
import script from "./checkpeople.vue?vue&type=script&lang=js&"
export * from "./checkpeople.vue?vue&type=script&lang=js&"
import style0 from "./checkpeople.vue?vue&type=style&index=0&id=614268a6&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614268a6",
  null
  
)

export default component.exports